import { ajaxSpinner } from '../util/ajaxSpinner';

export default {
  init() {
  },
  finalize() {

    // Toggle filters on mobile
    $('.toggle-filters-btn').on('click', function() {
      $('.card-filter').stop().slideToggle(200);
    });

    /**
     * Filters
     */
    $('input[name="search-query"]').on('keyup', function () {
      const $this = $(this);
      const searchQuery = $this.val();

      setTimeout(function () {
        if (searchQuery === $this.val()) {
          $('#load-more').data('page', 1);
          $('.job-items-container').empty();
          load_news();
        }
      }, 1000);
    });

    $('.location-checkbox').change(function () {
      $('#load-more').data('page', 1);
      $('.job-items-container').empty();
      load_news();
    })

    $('.type-checkbox').change(function () {
      $('#load-more').data('page', 1);
      $('.job-items-container').empty();
      load_news();
    })

    $('.contract-type-checkbox').change(function () {
      $('#load-more').data('page', 1);
      $('.job-items-container').empty();
      load_news();
    })

    /**
     * clear filters
     */
    $('.clear-filters').on('click', function () {
      $('#load-more').data('page', 1);
      $('.job-items-container').empty();

      $('input[name="search-query"]').empty();

      $('.location-checkbox').each(function () {
        $(this).prop('checked', false);
      });

      $('.type-checkbox').each(function () {
        $(this).prop('checked', false);
      });

      $('.contract-type-checkbox').each(function () {
        $(this).prop('checked', false);
      });

      load_news();
    });

    /**
     * Load more
     */
    $('#load-more').click(function () {
      load_news();
    });

    var in_progress = false;

    function load_news() {

      if (in_progress)
        return;
      else
        in_progress = true;

      freeze_filters();

      /**
       * Locations.
       */


      var locs = [];
      $('.location-checkbox').each(function () {
        if (this.checked) {
          locs.push($(this).val());
        }
      })

      locs = locs.join(',');

      /**
       * types.
       */
      var types = [];
      $('.type-checkbox').each(function () {
        if (this.checked) {
          types.push($(this).val());
        }
      })

      types = types.join(',');

      /**
       * contract types.
       */
      var contract_types = [];
      $('.contract-type-checkbox').each(function () {
        if (this.checked) {
          contract_types.push($(this).val());
        }
      })

      contract_types = contract_types.join(',');


      /**
       * search query.
       */
      var query = '';
      if ($('input[name="search-query"]').val() !== '') {
        query = $('input[name="search-query"]').val();
      }

      /**
       * Get current page.
       */
      var current_page = parseInt($('#load-more').data('page'));
      const spinner = new ajaxSpinner($('.job-items-container'));
      const lang = $('body').data('lang');

      $.ajax({
        url: `/wp-json/jobs-api/v1/get?page=${current_page}`,
        data: {
          page: current_page,
          location: locs,
          type: types,
          contract_type: contract_types,
          query: query,
          lang: lang,
        },
      })
        .done(function (res) {

          // Append posts to page.
          var read_more = (lang == 'cy' ? 'Darllen mwy' : 'Read more');

          const textSalary = $('.job-listing-wrap').data('text-salary');
          const textDate = $('.job-listing-wrap').data('text-date');

          res.posts.forEach(function (post) {

            let jobLocationSpan = '';

            if (post.acf.location) {
              let locationText = '';
              
              if (post.acf.location.name) {
                locationText = post.acf.location.name;
              } else if (post.acf.location.length > 0) {
                post.acf.location.forEach((location, i) => {
                  if (location.name) {
                    locationText += location.name;

                    if (i + 1 < post.acf.location.length) {
                      locationText += ', ';
                    }
                  }
                });
              }

              jobLocationSpan = `<span class="job-location">${locationText}</span>`;
            }

            let closingDate = '';

            if (post.acf.closing_date) {
              closingDate = `<p><span class="font-weight-4">${textDate}: </span> ${post.acf.closing_date}</p>`;
            }

            let summary = '';

            if (post.acf.summary) {
              summary = `<p>${post.acf.summary}</p>`;
            }

            let type_colour = '';

            if (post.type_colour) {
              type_colour = 'job-colour job-colour-' + post.type_colour;
            }

            let meithrin_benefits_link = '';

            if (post.job_type) {
              if (post.job_type == 'meithrin') {
                const meithrinBenefitsLink = $('#page-data').data('mudiad-meithrin-benefits-link');
                const meithrinBenefitsLabel = $('#page-data').data('mudiad-meithrin-benefits-label');

                if (meithrinBenefitsLabel != '') {
                  meithrin_benefits_link = `<a href="${meithrinBenefitsLink}" target="_blank" class="meithrin-benefits-link">${meithrinBenefitsLabel}</a>`;
                }
              }
            }

            var o = `
                <div class="card card-job job-hover ${type_colour}">
                  <div class="card-body">
                    <div class="title-location">
                      <span class="job-title">${post.post_title}</span>
                      ${jobLocationSpan}
                      ${summary}
                    </div>                   
                    <div class="salary-date">
                      <p><span class="font-weight-4">${textSalary}: </span>${post.acf.salary}</p>
                      ${closingDate}
                    </div>
                    <div class="time-more">
                      <span class="time"></span>
                      <div class="read-more-selector">
                        ${meithrin_benefits_link}
                        <a href="${post.permalink}" target="_blank" class="btn btn-primary read-more-btn" data-job="${post.ID}">${read_more}</a>
                      </div>
                    </div>
                  </div>
                </div>`;

            $('.job-items-container').append(o);

            if (res.found_posts !== 6) {
              $('#load-more').fadeOut();
            }
          })

          /**
           * Update page.
           */
          $('#load-more').data('page', current_page + 1);
          in_progress = false;
          unfreeze_filters();
          spinner.remove();
        })
        .error(function () {
          in_progress = false;
          unfreeze_filters();
          spinner.remove();
        })
    }

    load_news();

    function freeze_filters() {
      $('input[name="search-query"]').prop('disabled', true);
      $('.location-checkbox').prop('disabled', true);
      $('.type-checkbox').prop('disabled', true);
      $('.contract-type-checkbox').prop('disabled', true);
      $('.clear-filters').prop('disabled', true);
      $('.card-job').addClass('loading-frozen');
    }

    function unfreeze_filters() {
      $('input[name="search-query"]').prop('disabled', false);
      $('.location-checkbox').prop('disabled', false);
      $('.type-checkbox').prop('disabled', false);
      $('.contract-type-checkbox').prop('disabled', false);
      $('.clear-filters').prop('disabled', false);
      $('.card-job').removeClass('loading-frozen');
    }

    function load_job(job, $container = null) {
      $('.detail-panel').removeClass('panel-open');

      //Reset all job detail group blocks to show
      $('.detail-panel .group').show();
      $('.detail-panel').data('id', job);

      let spinner;
      if ($container) {
        spinner = new ajaxSpinner($container);
      }
      const lang = $('body').data('lang');

      $.ajax({
        url: `/wp-json/wp/v2/jobs/${job}?lang=${lang}`,
      })
        .done(function (res) {
          $('.detail-panel .job-attachments').addClass('d-none');
          $('.detail-panel .job-attachments .job-attachments-list').empty();

          if (res) {
            // Add to detail panel and fade in.
            // $('.detail-panel .apply-btn').attr('href', $('.detail-panel .job_permalink').val() + res.id);
        
            $('.detail-panel .title').text(res.title.rendered);
            
            //If statements used to hide block if fields are empty.
            //Job Desc field
            if(res.content.rendered){
              $('.detail-panel .job-desc').html(res.content.rendered);
            }
            else{
              $('.detail-panel .job-desc').parent().hide();
            }
            
            
            //Interview block
            if(res.acf.interview_date){
              $('.detail-panel .interview-date').text(res.acf.interview_date);
            }
            else{
              $('.detail-panel .interview-date').parent().hide();
            }


            //General info block
            if(res.acf.salary || res.acf.hours){
              $('.detail-panel .salary').text(res.acf.salary);
              $('.detail-panel .hours').text(res.acf.hours);
            }
            else{
              $('.detail-panel .salary').parent().hide();
            }

            //Qualification info block
            if(res.acf.qualifications){
              $('.detail-panel .quals').text(res.acf.qualifications);
            }
            else{
              $('.detail-panel .quals').parent().hide();
            }

            //additional info block
            if(res.acf.additional_info){
              $('.detail-panel .add-info').text(res.acf.additional_info);
            }
            else{
              $('.detail-panel .add-info').parent().hide();
            }

            let jobLocationText = '';

            if (res.acf.location) {
              
              if (res.acf.location.name) {
                jobLocationText = res.acf.location.name;
              } else if (res.acf.location.length > 0) {
                res.acf.location.forEach((location, i) => {
                  if (location.name) {
                    jobLocationText += location.name;

                    if (i + 1 < res.acf.location.length) {
                      jobLocationText += ', ';
                    }
                  }
                });
              }
            }

            if (jobLocationText != '') {
              $('.detail-panel .job-location').show();
              $('.detail-panel .job-location').text(jobLocationText);
            } else {
              $('.detail-panel .job-location').hide();
            }

            $('.detail-panel .closing-date').text(res.acf.closing_date);

            if (res.acf.attachments && res.acf.attachments.length > 0) {
              $('.detail-panel .job-attachments').removeClass('d-none');

              res.acf.attachments.forEach((attachment) => {
                if (attachment.file && attachment.attachment_title) {
                  const fileName = attachment.file.filename;
                  const fileNameSplit = fileName.split('.');

                  var fileType = '';

                  if (fileNameSplit && fileNameSplit.length > 0) {
                    fileType = fileNameSplit[fileNameSplit.length - 1];
                  }
                  
                  const $attach = $(`
                    <div class="job-attachment">
                      <a href="${attachment.file.url}" target="_blank" class="attachment-link">
                        ${attachment.attachment_title}
                      </a>
                      <span class="attachment-properties">
                        ${fileType}
                      </span>
                    </div>`);

                  $('.detail-panel .job-attachments .job-attachments-list').append($attach);
                }
              });
            }

            $('.detail-panel').addClass('panel-open');

            const detailHeaderHeight = $('.detail-panel .group-header').outerHeight() + 40;
            $('.detail-panel .panel-content').css({ maxHeight: `calc(100vh - ${detailHeaderHeight}px)` });
            $('body').addClass('modal-open-sm');
          }

          if (spinner) {
            spinner.remove();
            $container.find('.btn').show();
          }
        })
    }
    /**
     * AJAX Load job detail.
     */
    // $('body').click(function (e) {
    //   var $target = $(e.target);

    //   if ($target.data('job')) {
    //     e.preventDefault();

    //     $target.hide();

    //     var job = $target.data('job');

    //     $('body').data('scroll-y', $(window).scrollTop());
    //     load_job(job, $target.parent())

    //   }
    // });

    // Close detail panel.
    $('#close').click(function () {
      $('body').removeClass('modal-open-sm');
      $('.detail-panel').removeClass('panel-open');

      if ($(window).outerWidth() < 1420) {
        $(window).scrollTop($('body').data('scroll-y'));
      }
    })

    // Copy link
    $('#copy-link').on('click', function() {
      if ($('#copy-link').data('status') == 'ok') {
        var permalink = window.location.href.split('?')[0];

        if (permalink.charAt(permalink.length - 1) != '/') {
          permalink += '/';
        }

        permalink += '?job=' + $('.detail-panel').data('id');

        $('#copy-link-input').val(permalink);
        $('#copy-link-input').removeClass('d-none');
        $('#copy-link-input').focus();
        $('#copy-link-input').select();
        document.execCommand('copy');
        $('#copy-link-input').addClass('d-none');

        const currentText = $('#copy-link').html();

        $('#copy-link').html($('#copy-link-copied').html());
        $('#copy-link').data('status', 'pause');

        setTimeout(() => {
          $('#copy-link').html(currentText);
          $('#copy-link').data('status', 'ok');
        }, 1000);
      }
    });

    // Get & load a job if it exists as a query parameter.
    const urlParams = new URLSearchParams(window.location.search);
    const job = urlParams.get('job');

    if (job) {
      load_job(job);
      document.documentElement.scrollTop = document.body.scrollTop = $('#view-jobs').offset().top - 100;
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-jobs-listing.js